import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static values = {
    funnelLabels: Array,
    funnelData: Array,
    etapaLabels: Array,
    etapaData: Array,
    fonteLabels: Array,
    fonteData: Array,
    segmentoLabels: Array,
    segmentoData: Array,
    evolucaoLabels: Array,
    evolucaoNovos: Array,
    evolucaoR1: Array,
    metaDiaria: Number,
    contatosHoje: Number,
    metaSemanalContatos: Number,
    contatosSemana: Number,
    contatosDiaLabels: Array,
    contatosDiaData: Array,
    contatosDiaMeta: Array,
    motivosPerdaLabels: Array,
    motivosPerdaData: Array,
  }

  connect() {
    this.renderFunnel()
    this.renderEtapas()
    this.renderFonte()
    this.renderSegmento()
    this.renderEvolucao()
    this.renderMetaDiaria()
    this.renderMetaSemanalContatos()
    this.renderContatosDia()
    this.renderMotivosPerda()
  }

  renderFunnel() {
    const el = this.element.querySelector("#chart-funnel")
    if (!el) return
    new Chart(el, {
      type: "bar",
      data: {
        labels: this.funnelLabelsValue,
        datasets: [{
          label: "Prospects",
          data: this.funnelDataValue,
          backgroundColor: ["#3b82f6", "#f59e0b", "#f97316", "#10b981", "#ef4444"],
          borderRadius: 6,
          borderSkipped: false,
        }]
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } } }
      }
    })
  }

  renderEtapas() {
    const el = this.element.querySelector("#chart-etapas")
    if (!el) return
    new Chart(el, {
      type: "bar",
      data: {
        labels: this.etapaLabelsValue,
        datasets: [{
          label: "Taxa de conversão (%)",
          data: this.etapaDataValue,
          backgroundColor: ["#3b82f6", "#f59e0b", "#10b981"],
          borderRadius: 6,
          borderSkipped: false,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: { y: { beginAtZero: true, max: 100, ticks: { callback: v => v + "%" } } }
      }
    })
  }

  renderFonte() {
    const el = this.element.querySelector("#chart-fonte")
    if (!el) return
    const labels = this.fonteLabelsValue
    if (!labels.length) return
    new Chart(el, {
      type: "doughnut",
      data: {
        labels,
        datasets: [{
          data: this.fonteDataValue,
          backgroundColor: ["#3b82f6","#10b981","#f59e0b","#f97316","#ef4444","#8b5cf6","#ec4899","#14b8a6"],
          hoverOffset: 4
        }]
      },
      options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { position: "bottom" } } }
    })
  }

  renderSegmento() {
    const el = this.element.querySelector("#chart-segmento")
    if (!el) return
    const labels = this.segmentoLabelsValue
    if (!labels.length) return
    new Chart(el, {
      type: "doughnut",
      data: {
        labels,
        datasets: [{
          data: this.segmentoDataValue,
          backgroundColor: ["#6366f1","#0ea5e9","#d97706","#dc2626","#16a34a","#9333ea","#db2777","#0891b2"],
          hoverOffset: 4
        }]
      },
      options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { position: "bottom" } } }
    })
  }

  renderEvolucao() {
    const el = this.element.querySelector("#chart-evolucao")
    if (!el) return
    new Chart(el, {
      type: "line",
      data: {
        labels: this.evolucaoLabelsValue,
        datasets: [
          {
            label: "Novos prospects",
            data: this.evolucaoNovosValue,
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59,130,246,0.1)",
            tension: 0.4,
            fill: true,
            pointRadius: 4,
          },
          {
            label: "R1 Agendadas",
            data: this.evolucaoR1Value,
            borderColor: "#10b981",
            backgroundColor: "rgba(16,185,129,0.1)",
            tension: 0.4,
            fill: true,
            pointRadius: 4,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: "top" } },
        scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } }
      }
    })
  }

  renderMetaDiaria() {
    const el = this.element.querySelector("#chart-meta-diaria")
    if (!el) return
    const valor = this.contatosHojeValue
    const meta = this.metaDiariaValue || 1
    const restante = Math.max(meta - valor, 0)
    new Chart(el, {
      type: "doughnut",
      data: {
        labels: ["Alcançado", "Restante"],
        datasets: [{
          data: [valor, restante],
          backgroundColor: ["#10b981", "#e5e7eb"],
          borderWidth: 0,
          cutout: "75%"
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { enabled: false } }
      }
    })
  }

  renderContatosDia() {
    const el = this.element.querySelector("#chart-contatos-dia")
    if (!el) return
    new Chart(el, {
      data: {
        labels: this.contatosDiaLabelsValue,
        datasets: [
          {
            type: "bar",
            label: "Contatos",
            data: this.contatosDiaDataValue,
            backgroundColor: "#3b82f6",
            borderRadius: 4,
            borderSkipped: false,
            order: 2,
          },
          {
            type: "line",
            label: `Meta (${this.metaDiariaValue}/dia útil)`,
            data: this.contatosDiaMetaValue,
            borderColor: "#ef4444",
            backgroundColor: "#ef4444",
            borderDash: [6, 4],
            borderWidth: 2,
            pointRadius: 0,
            spanGaps: false,
            tension: 0,
            order: 1,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { position: "top" } },
        scales: { y: { beginAtZero: true, ticks: { stepSize: 5 } } }
      }
    })
  }

  renderMotivosPerda() {
    const el = this.element.querySelector("#chart-motivos-perda")
    if (!el) return
    const labels = this.motivosPerdaLabelsValue
    const data = this.motivosPerdaDataValue
    if (!data.some(v => v > 0)) return
    new Chart(el, {
      type: "doughnut",
      data: {
        labels,
        datasets: [{
          data,
          backgroundColor: ["#ef4444", "#f97316", "#f59e0b", "#6b7280"],
          hoverOffset: 4
        }]
      },
      options: { responsive: true, maintainAspectRatio: false, plugins: { legend: { position: "bottom" } } }
    })
  }

  renderMetaSemanalContatos() {
    const el = this.element.querySelector("#chart-meta-semanal-contatos")
    if (!el) return
    const valor = this.contatosSemanaValue
    const meta = this.metaSemanalContatosValue || 1
    const restante = Math.max(meta - valor, 0)
    new Chart(el, {
      type: "doughnut",
      data: {
        labels: ["Alcançado", "Restante"],
        datasets: [{
          data: [valor, restante],
          backgroundColor: ["#10b981", "#e5e7eb"],
          borderWidth: 0,
          cutout: "75%"
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { enabled: false } }
      }
    })
  }
}
